module.exports = __webpack_public_path__ + "static/media/banner-mobile@2x.cd29fe10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about-us/images/banner-mobile@2x.jpg
// module id = 1103
// module chunks = 2